import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import Screens from '..';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { MOUNT_INTENTS } from '../../utils/routeParamConstants';
import Utils from '../../utils';
import audio from '../../utils/audio';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import NotificationContext from '../../context/NotificationContext';
import { onGuestActivate } from '../../utils/guestLogin';
var Start = /*#__PURE__*/function (_Component) {
  function Start(props) {
    var _this;
    _classCallCheck(this, Start);
    _this = _callSuper(this, Start, [props]);
    _this.isRN = Utils.isReactNative();
    _this.checkRecoverPassRequest = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var urlParams, id, token, platform, recoverRequest;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            urlParams = QueryParamsProxy.getAllParams();
            if (urlParams) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            id = urlParams.i;
            token = urlParams.t;
            platform = urlParams.platform;
            if (!(id && token && platform)) {
              _context.next = 11;
              break;
            }
            _context.next = 9;
            return _this.props.postRecoverPasswordTokenCheck(id, token);
          case 9:
            recoverRequest = _context.sent;
            if (!recoverRequest.success) {
              _this.setState({
                showRecoverPass: {
                  visible: true,
                  invalid: true,
                  message: recoverRequest.error
                }
              });
            } else {
              _this.setState({
                showRecoverPass: {
                  visible: true,
                  invalid: false,
                  id: id,
                  token: token
                }
              });
            }
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    _this.closeModal = function () {
      audio.onClick();
      audio.playSfx('popUpReverse', true, 1);
      _this.setState({
        isVisible: false,
        terms: false,
        showSignUpForm: false,
        showRecoverPass: _objectSpread(_objectSpread({}, _this.state.showRecoverPass), {}, {
          visible: false
        })
      });
    };
    _this.openModal = function (mountIntent) {
      audio.playSfx('popUp', true, 1);
      _this.setState({
        isVisible: true,
        terms: false,
        termsAccepted: false,
        mountIntent: mountIntent
      });
    };
    _this._loginHandler = function () {
      return QueryParamsProxy.navigate(_this.props.navigation, Screens.Login);
    };
    _this.onAccountActivate = function () {
      audio.onClick();
      _this._loginHandler();
    };
    _this.handleGuestActivate = function () {
      return onGuestActivate(_this.state.termsAccepted, _this.state.mountIntent, _this.setState.bind(_this), _this.openModal, _this.closeModal, _this.context.addNotification);
    };
    _this.onFacebookActivate = function () {
      audio.onClick();
      var _this$state = _this.state,
        termsAccepted = _this$state.termsAccepted,
        mountIntent = _this$state.mountIntent;
      if (termsAccepted && mountIntent === MOUNT_INTENTS.FACEBOOK_LOGIN) {
        _this.props.mountIntent.facebook();
      } else {
        _this.openModal(MOUNT_INTENTS.FACEBOOK_LOGIN);
      }
    };
    _this.onGoogleActivate = function () {
      audio.onClick();
      var _this$state2 = _this.state,
        termsAccepted = _this$state2.termsAccepted,
        mountIntent = _this$state2.mountIntent;
      if (termsAccepted && mountIntent === MOUNT_INTENTS.GOOGLE_LOGIN) {
        _this.props.mountIntent.google();
      } else {
        _this.openModal(MOUNT_INTENTS.GOOGLE_LOGIN);
      }
    };
    _this.onAppleActivate = function () {
      audio.onClick();
      var _this$state3 = _this.state,
        termsAccepted = _this$state3.termsAccepted,
        mountIntent = _this$state3.mountIntent;
      if (termsAccepted && mountIntent === MOUNT_INTENTS.APPLE_LOGIN) {
        _this.props.mountIntent.apple();
      } else {
        _this.openModal(MOUNT_INTENTS.APPLE_LOGIN);
      }
    };
    _this.setTerms = function () {
      audio.onClick();
      _this.setState({
        terms: !_this.state.terms
      });
    };
    _this.onSubmit = function () {
      audio.onClick();
      _this.setState({
        termsAccepted: true
      }, function () {
        _this.closeModal();
        switch (_this.state.mountIntent) {
          case MOUNT_INTENTS.FACEBOOK_LOGIN:
            _this.onFacebookActivate();
            break;
          case MOUNT_INTENTS.APPLE_LOGIN:
            _this.onAppleActivate();
            break;
          case MOUNT_INTENTS.GOOGLE_LOGIN:
            _this.onGoogleActivate();
            break;
          case MOUNT_INTENTS.GUEST_LOGIN:
            _this.handleGuestActivate();
            break;
          default:
            break;
        }
      });
    };
    _this._signupHandler = function () {
      audio.onClick();
      _this.setState({
        showSignUpForm: true
      });
    };
    _this._cancelHandler = function () {
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Start);
    };
    _this.state = {
      isVisible: false,
      terms: false,
      socialError: false,
      isLoading: false,
      mountIntent: '',
      termsAccepted: false,
      showSignUpForm: false,
      showRecoverPass: {}
    };
    return _this;
  }
  _inherits(Start, _Component);
  return _createClass(Start, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Utils.isWebOrMobileWeb() && this.checkRecoverPassRequest();
      audio.playSfx('crowdsTalking', true, 0.7);
      var _this$props = this.props,
        navigation = _this$props.navigation,
        token = _this$props.token,
        restart = _this$props.restart;
      audio.setCurrentScreen(navigation.state.routeName);
      if (token.token && restart.token) {
        audio.fadeOut('crowdsTalking');
        QueryParamsProxy.navigate(navigation, Screens.Lobby);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      audio.fadeOut('crowdsTalking');
      audio.setCurrentScreen('');
    }
  }, {
    key: "render",
    value: function render() {
      return (
        // Pass state and handlers to platform renderer
        !this.props.token.token && this.props.render({
          loginHandler: this._loginHandler,
          onGuestActivate: this.handleGuestActivate,
          onFacebookActivate: this.onFacebookActivate,
          onGoogleActivate: this.onGoogleActivate,
          onAppleActivate: this.onAppleActivate,
          onAccountActivate: this.onAccountActivate,
          signupHandler: this._signupHandler,
          statusMessage: this.props.navigation.getParam(RouteParamConstants.PARAM_STATUS_MESSAGE),
          statusAction: this.props.navigation.getParam(RouteParamConstants.PARAM_ACTION),
          googleAuthServiceAvailable: this.props.googleAuthServiceAvailable,
          isVisible: this.state.isVisible,
          terms: this.state.terms,
          isLoading: this.state.isLoading,
          closeModal: this.closeModal,
          onSubmit: this.onSubmit,
          setTerms: this.setTerms,
          termsAndConditionsUrl: this.props.assetsUrls ? this.props.assetsUrls.termsAndConditions : '',
          privacyPolicyUrl: this.props.assetsUrls ? this.props.assetsUrls.privacyPolicy : '',
          showSignUpForm: this.state.showSignUpForm,
          recoverPasswordResponse: this.state.showRecoverPass,
          hasFacebook: hasFacebook
        })
      );
    }
  }]);
}(Component);
Start.contextType = NotificationContext;
export { Start as default };
var hasFacebook = ENVIRONMENT_VARIABLES.FACEBOOK_LOGIN === 'true';